import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';
import './ProductShowcase.css';
import Navbar from '../Navbar/Navbar';
import { useLanguage } from '../../context/LanguageContext';

const ProductShowcase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, lang } = useLanguage();
  
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [translatedData, setTranslatedData] = useState({});

  // KANKA SİHİRLİ ÇEVİRİ MOTORU
  const translateText = async (text, targetLang) => {
    if (!text || targetLang === 'TR') return text;
    const cacheKey = `${text}_${targetLang}`;
    if (translatedData[cacheKey]) return translatedData[cacheKey];

    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=${targetLang.toLowerCase()}&dt=t&q=${encodeURI(text)}`
      );
      const data = await response.json();
      const result = data[0][0][0];
      setTranslatedData(prev => ({ ...prev, [cacheKey]: result }));
      return result;
    } catch (error) {
      return text;
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const docRef = doc(db, "products", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setProduct({ id: docSnap.id, ...data });
          
          // Ürün yüklendiğinde çevirileri tetikle
          if (lang !== 'TR') {
            const toTranslate = [
              data.title, data.description, data.animalGroup, 
              data.packaging, data.usageGuide
            ];
            toTranslate.forEach(item => translateText(item, lang));
          }
        } else {
          navigate('/urunlerimiz');
        }
      } catch (error) {
        console.error("Firebase Hatası:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
    window.scrollTo(0, 0);
  }, [id, navigate, lang]);

  const getDisplay = (originalText) => {
    const cacheKey = `${originalText}_${lang}`;
    return translatedData[cacheKey] || originalText;
  };

  if (loading) return <div className="loader-screen"><span className="spinner"></span></div>;

  const analysis = product?.analysis || {};

  return (
    <div className="product-showcase-page">
      <Navbar />
      
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-left">
            <div className="badge-area">
              <span className="category-badge">
                {getDisplay(product.animalGroup) || t('catalog.productShowcase.infoTitle')}
              </span>
            </div>
            <h1 className="product-title">{getDisplay(product.title)}</h1>
            <p className="product-subtitle">{getDisplay(product.description)}</p>
            
            <div className="hero-actions">
              <button className="btn-green" onClick={() => navigate('/urunlerimiz')}>
                {t('catalog.productShowcase.returnBtn')}
              </button>
              <button className="btn-white">
                {t('catalog.productShowcase.techInfo')}
              </button>
            </div>
          </div>

          <div className="hero-right">
            <div className="product-image-frame">
              <img src={product.imageUrl} alt={getDisplay(product.title)} />
            </div>
          </div>
        </div>
      </section>

      <section className="details-section">
        <div className="details-grid">
          
          <div className="info-card">
            <h3 className="card-header">{t('catalog.productShowcase.infoTitle')}</h3>
            <div className="info-content">
              <p><strong>{t('catalog.productCard.animal')}</strong> {getDisplay(product.animalGroup)}</p>
              <p><strong>{t('catalog.productCard.pkg')}</strong> {getDisplay(product.packaging)}</p>
              <p><strong>{t('catalog.productCard.license')}</strong> {product.license}</p>
              <p><strong>{t('catalog.productCard.barcode')}</strong> {product.barcode}</p>
            </div>
          </div>

          <div className="info-card">
            <h3 className="card-header">{t('catalog.productShowcase.analysisTitle')}</h3>
            <table className="tech-table">
              <thead>
                <tr>
                  <th>{t('catalog.productShowcase.tableComp')}</th>
                  <th>{t('catalog.productShowcase.tableVal')}</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>{t('catalog.productCard.analysis1')}</td><td>{analysis.hamProtein || "N/A"}</td></tr>
                <tr><td>{t('catalog.productCard.analysis2')}</td><td>{analysis.hamYag || "N/A"}</td></tr>
                <tr><td>{t('catalog.productCard.analysis4')}</td><td>{analysis.hamSeluloz || "N/A"}</td></tr>
                <tr><td>{t('catalog.productCard.analysis3')}</td><td>{analysis.hamKul || "N/A"}</td></tr>
                <tr><td>{t('catalog.productCard.analysis5')}</td><td>{analysis.nem || "N/A"}</td></tr>
              </tbody>
            </table>
          </div>

          <div className="info-card">
            <h3 className="card-header">{t('catalog.productShowcase.guideTitle')}</h3>
            <div className="guide-content">
              <p>{getDisplay(product.usageGuide)}</p>
            </div>
          </div>
        </div>

        <div className="warning-note">
          {t('catalog.productShowcase.warning')}
        </div>

        <div className="showcase-footer-info">
          <p className="corporate-name">{t('catalog.productShowcase.footerName')}</p>
          <p className="corporate-details">
            {t('catalog.productShowcase.footerAddr')} • 
            Tel: 0346 218 18 25 / 0555 876 99 66 • 
            www.bigmagrup.com.tr
          </p>
        </div>
      </section>
    </div>
  );
};

export default ProductShowcase;